function Nbsp() {
    return '\u00A0';
}

export default Nbsp;
